import { Button, LuneThemeNew } from '@lune-fe/lune-ui-lib'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
const { palette } = LuneThemeNew

export interface SortButtonProps {
    active: string
    options: [string, string]
    onClick: (newVal: string) => void
}

export const SortButton = ({ active, options, onClick }: SortButtonProps) => {
    // this button can have 3 states
    // 0 -> not selected
    // 1 -> ASC
    // 2 -> DESC
    const state = options.includes(active) ? (active.includes('ASC') ? 1 : 2) : 0
    const handleClick = () => {
        if (state === 0) {
            onClick(options[0])
        } else if (state === 1) {
            onClick(options[0])
        } else {
            onClick(options[1])
        }
    }

    return (
        <Button
            variant={'text'}
            iconButton
            leftIcon={<ArrowDownwardIcon />}
            sx={{
                width: '24px',
                height: '24px',
                p: 0,
                svg: {
                    width: '20px',
                    height: '20px',
                    color: state === 0 ? palette.Grey400 : palette.Grey900,
                },
                transform: `rotate(${state === 1 ? '180deg' : '0'})`,
                transition: 'transform .3s cubic-bezier(0.4, 0, 1, 1)',
                verticalAlign: 'bottom',
                mr: 1 / 2,
            }}
            onClick={handleClick}
        />
    )
}
